import React from 'react';
import styles from './StripeTestCheckout.module.scss';

const OrderSummary = ({ cart, amount }) => {
  const orderPackages = cart?.orderPackages || [];

  return (
    <div className={styles.orderSummary}>
      <h2 className={styles.orderSummaryTitle}>Order Summary</h2>

      <div className={styles.orderItems}>
        {orderPackages.map((orderPackage, index) => {
          const student = orderPackage.student;
          const option = orderPackage.apiOption || orderPackage.option?.();
          const packageName = option?.name || 'Package';

          const imageUrl = orderPackage.firstPoseUrl;

          return (
            <div key={orderPackage.id || index} className={styles.orderItem}>
              {imageUrl && (
                <img
                  src={imageUrl}
                  alt={student?.firstName || 'Student'}
                  className={styles.studentImage}
                />
              )}
              <div className={styles.orderItemDetails}>
                <div className={styles.packageName}>{packageName}</div>
                {student && (
                  <div className={styles.studentName}>
                    {student.firstName} {student.lastName}
                  </div>
                )}
                <div className={styles.packagePrice}>
                  ${(orderPackage.price || 0).toFixed(2)}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.orderTotals}>
        <div className={styles.orderTotalRow}>
          <span>Subtotal</span>
          <span>${(cart?.subtotal || 0).toFixed(2)}</span>
        </div>
        <div className={styles.orderTotalRow}>
          <span>Shipping</span>
          <span>{cart?.shipping > 0 ? `$${cart.shipping.toFixed(2)}` : 'FREE'}</span>
        </div>
        <div className={styles.orderTotalRow}>
          <span>Tax</span>
          <span>${(cart?.apiTax || 0).toFixed(2)}</span>
        </div>
        <div className={`${styles.orderTotalRow} ${styles.orderTotalFinal}`}>
          <span>Total</span>
          <span>${amount}</span>
        </div>
      </div>

      <div className={styles.securePayment}>
        <span className={styles.lockIcon}>🔒</span>
        <span>Secure SSL encrypted payment</span>
      </div>
    </div>
  );
};

export default OrderSummary;
